<script setup lang="ts">
import InputBox from "@/components/shared/InputBox.vue"
import { normalizeQualityName } from "@/utils/qualityName"

const props = defineProps<{ modelValue: string }>()
const emit = defineEmits<{ "update:modelValue": [value: string] }>()
let composing = false
let blurredWhileComposing = false

function normalize(event: FocusEvent | CompositionEvent) {
  if (event.target instanceof HTMLInputElement) {
    emit("update:modelValue", normalizeQualityName(event.target.value))
  }
}

function onCompositionStart() {
  composing = true
}

function onBlur(event: FocusEvent) {
  if (composing) blurredWhileComposing = true
  else normalize(event)
}

function onCompositionEnd(event: CompositionEvent) {
  composing = false
  if (blurredWhileComposing) normalize(event)
  blurredWhileComposing = false
}
</script>

<template>
  <InputBox
    :model-value="props.modelValue"
    @update:model-value="emit('update:modelValue', String($event ?? ''))"
    type="text"
    field="name"
    :label="$t('item.name')"
    :guide="$t('item.nameWhitespaceGuide')"
    required
    @focusout="onBlur"
    @compositionstart="onCompositionStart"
    @compositionend="onCompositionEnd"
  />
</template>
